import { render } from "./safeScoreSelector.vue?vue&type=template&id=b3b24664&scoped=true"
import script from "./safeScoreSelector.vue?vue&type=script&lang=js"
export * from "./safeScoreSelector.vue?vue&type=script&lang=js"

import "./safeScoreSelector.vue?vue&type=style&index=0&id=b3b24664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b24664"]])

export default __exports__